import { Button, Card, CardBody, cn, Link } from '@heroui/react'
import { Frequency, Product } from '@interfaces/pricing'
import { useState } from 'react'

interface PricingCardProps {
  frequency: Frequency
  product: Product
  onSubscribe: () => Promise<void>
  ctaText?: string
}

const PricingCard = ({ frequency, product, onSubscribe, ctaText }: PricingCardProps) => {
  const [loading, setLoading] = useState(false)

  const subscribe = async () => {
    setLoading(true)
    await onSubscribe()
    setLoading(false)
  }

  const { price, priceSuffix, buttonText, buttonVariant } = product

  return (
    <Card className={cn('w-full')} shadow="none">
      <CardBody
        className="flex flex-col items-center justify-between gap-4 p-4"
        style={{
          background: 'linear-gradient(to right, rgba(198, 246, 72, 0.2), transparent 50%, rgba(198, 246, 72, 0.2))',
        }}
      >
        <div className="flex flex-col items-start gap-1">
          <h2 className="text-4xl font-medium">
            {price[frequency.key].displayPrice}
            <span className="text-small font-medium text-default-400">
              {priceSuffix ? `/${product?.priceSuffix}/${frequency.priceSuffix}` : `/${frequency.priceSuffix}`}
            </span>
          </h2>
          <p className="text-small text-default-500">Cancel anytime.</p>
        </div>
        <Button
          isLoading={loading}
          as={Link}
          color="primary"
          style={{ backgroundColor: '#c6f648', color: '#000' }}
          onPress={subscribe}
          variant={buttonVariant}
          className="w-[50%] min-w-[10rem] px-8"
        >
          {ctaText || buttonText}
        </Button>
      </CardBody>
    </Card>
  )
}

export default PricingCard
